import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { ProductionListItem, ProductionStatus, ReleaseLevel } from '@/features/stacktrace/productions/-query/type';

/**
 * プロダクション 一覧 (PN Force グローバルメニュー) のテーブル列ID。
 *
 * 表示項目:
 *   リリース / プロダクト / レベル / ステータス /
 *   説明 / リリース予定日 / リリース日時 /
 *   作成日時 / 更新日時
 */
export const ProductionTableColumns = {
  RELEASE: 'RELEASE',
  PRODUCT: 'PRODUCT',
  RELEASE_LEVEL: 'RELEASE_LEVEL',
  STATUS: 'STATUS',
  DESCRIPTION: 'DESCRIPTION',
  PLANNED_RELEASE_DATE: 'PLANNED_RELEASE_DATE',
  RELEASED_AT: 'RELEASED_AT',
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT'
} as const;
export type ProductionTableColumns = EnumUnion<typeof ProductionTableColumns>;
type ProductionReleaseColumn = {
  id: string;
  productionId: string;
  releaseId: string;
  name: string;
};
type ProductionProductColumn = {
  id: string;
  name: string;
};
export type ProductionTableRowData = {
  [ProductionTableColumns.RELEASE]: ProductionReleaseColumn;
  [ProductionTableColumns.PRODUCT]: ProductionProductColumn;
  [ProductionTableColumns.RELEASE_LEVEL]: ReleaseLevel | undefined;
  [ProductionTableColumns.STATUS]: ProductionStatus | undefined;
  [ProductionTableColumns.DESCRIPTION]: string | null;
  [ProductionTableColumns.PLANNED_RELEASE_DATE]: string | null;
  [ProductionTableColumns.RELEASED_AT]: string | null;
  [ProductionTableColumns.CREATED_AT]: string;
  [ProductionTableColumns.UPDATED_AT]: string;
};
export const convertProductionItemToTableRow = (item: ProductionListItem): ProductionTableRowData => {
  return {
    [ProductionTableColumns.RELEASE]: {
      id: item.id,
      productionId: item.id,
      releaseId: item.releaseId,
      name: item.releaseName
    },
    [ProductionTableColumns.PRODUCT]: {
      id: item.productId,
      name: item.productName
    },
    [ProductionTableColumns.RELEASE_LEVEL]: item.releaseLevel,
    [ProductionTableColumns.STATUS]: item.status,
    [ProductionTableColumns.DESCRIPTION]: item.description,
    [ProductionTableColumns.PLANNED_RELEASE_DATE]: item.plannedReleaseDate,
    [ProductionTableColumns.RELEASED_AT]: item.releasedAt,
    [ProductionTableColumns.CREATED_AT]: item.createdAt,
    [ProductionTableColumns.UPDATED_AT]: item.updatedAt
  };
};